import React from "react";
import Icon from "../../svg/Icon.js";
import { theme } from "../../styles/theme.css.js";

interface Props {
    state: "empty" | "correct" | "wrong" | "picked";
}

const colorMap = {
    empty: "grey",
    correct: "green",
    wrong: "red",
    picked: theme.colors.purpleButton,
};

const VariantIcon: React.FC<Props> = ({ state }) => (
    <Icon k={state} style={{ color: colorMap[state] }} />
);

export default VariantIcon;
